import { useSelector } from 'react-redux';
import { SuccessMessageWithNBA } from '../../../../../global/models/epi-model';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { MidyearEnrollmentState } from '../mid-year-model';

export function useMidYearFatalError() {
	const midYearState = useSelector<TcsmStates, MidyearEnrollmentState>(state => state.midYearEnrollment);
	const messageMapping = useSelector<TcsmStates, { [key: string]: SuccessMessageWithNBA }>(a => a.epiProps?.siteSettingsState?.siteSettings?.apiResponseMessages);

	const apiResponse = midYearState?.currentMidYearEnrollment?.api_response;
	if (!apiResponse?.status || apiResponse.status === 'OK') return null;


	return messageMapping[apiResponse.status.toLowerCase()] ? messageMapping[apiResponse.status.toLowerCase()].title : apiResponse.message;
}